
<div class="d-flex flex-column h-100">
    <ag-grid-angular
        #reportingSetGrid 
        *ngIf="gridOptions != null"
        class="ag-theme-balham flex-fill"
        [gridOptions]="gridOptions"
        style="height:100%; width:100%;"
        [style.visibility]="isFirstLoad ? 'hidden' : 'visible'">
    </ag-grid-angular>
</div>
